import { HttpErrorResponse } from '@angular/common/http';

/** Extract a user-facing message from an API or HTTP error payload. */
export function extractHttpErrorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  if (!error) {
    return fallback;
  }

  if (typeof error === 'string') {
    return error.trim() || fallback;
  }

  if (error instanceof HttpErrorResponse) {
    return extractHttpErrorMessage(error.error ?? error.message, fallback);
  }

  if (typeof error === 'object') {
    const payload = error as Record<string, unknown>;

    if (typeof payload['message'] === 'string' && payload['message'].trim()) {
      return payload['message'].trim();
    }

    const errors = payload['errors'];
    if (errors && typeof errors === 'object') {
      const firstField = Object.values(errors as Record<string, unknown>)[0];
      if (Array.isArray(firstField) && typeof firstField[0] === 'string') {
        return firstField[0];
      }
      if (typeof firstField === 'string') {
        return firstField;
      }
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }

  return fallback;
}
